module.exports = __webpack_public_path__ + "static/media/yoshino_goto.34d9080b.png";